export enum NotifyPlatform {
    MESSAGE_NOTIFY = 'MESSAGE_NOTIFY',
    WX_OA_NOTIFY = 'WX_OA_NOTIFY',
}